import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import {
    Link,
    Box,
    Container
} from '@chakra-ui/react';
import { PrismicRichText } from "@prismicio/react"


export default function RichTextSlice({ slice }) {
    console.log(slice)
    return (
        <Container maxW="container.xl" mb="8">
            {slice.slice_label === "align_image_right" ? 
            (<Box id={slice.primary?.slice_id}>
                <Box w={{base: '100%', md: '50%'}} style={{float: 'right'}} ml="4" mb="2">
                    <GatsbyImage image={getImage(slice.primary.image.localFile)} alt={slice.primary.image.alt} style={{height: 'unset'}} imgStyle={{borderRadius: '0.5rem'}} />
                </Box>
                <PrismicRichText field={slice.primary.content1.richText} />
                
                <Box style={{clear: 'both'}} />
            </Box>) 
            : slice.slice_label === "align_image_left" ? (<Box id={slice.primary?.slice_id}>
                <Box w={{base: '100%', md: '50%'}} style={{float: 'left'}} mr="4" mb="2">
                    <GatsbyImage image={getImage(slice.primary.image.localFile)} alt={slice.primary.image.alt} style={{height: 'unset'}} imgStyle={{borderRadius: '0.5rem'}} />
                </Box>
                <PrismicRichText field={slice.primary.content1.richText} />
            </Box>)
            : (
                <Box id={slice.primary.slice_id}>
                    <PrismicRichText field={slice.primary.content1.richText} />
                    <Box mr="4" mb="2">
                        <Link href={slice.primary.image_link?.url} target={slice.primary.image_link?.link_type === 'Media' ? '_blank' : null }><GatsbyImage image={getImage(slice.primary.image.localFile)} alt={slice.primary.image.alt} style={{height: 'unset'}} imgStyle={{borderRadius: '0.5rem'}} /></Link>
                    </Box>
                </Box>
            )
            }
        </Container>
    )
}
